import { Alert } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)`
  margin-top: 20px;
  width: 100%;
`;
